// extracted by mini-css-extract-plugin
export default {"loadingDiv":"Home_loadingDiv__2NLnQ","carouselRow":"Home_carouselRow__zdYBZ","carousel":"Home_carousel__4kDkU"};